import * as React from "react";
import type { SVGProps } from "react";
const SvgFileQuestion02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 21.555H6a2.4 2.4 0 0 1-2.4-2.4v-14.4a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v4.2m-3.6 7.057c0-1.296 1.075-2.347 2.4-2.347 1.326 0 2.4 1.05 2.4 2.348 0 1.296-1.074 2.347-2.4 2.347m0 3.285v-.09M7.8 7.155H15m-7.2 3.6H15m-7.2 3.6h3.6"
    />
  </svg>
);
export default SvgFileQuestion02;
